import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * Represents a file which is uploaded.
 */
export default class FileUploadedJournalEvent extends JournalEvent {
  static override type = "file-uploaded-journal-event";

  @attr("string") declare title: string;

  @attr("string") declare body: string;

  @attr("string") declare fileSubType: string;

  static override validations(intl: IntlService) {
    return {
      title: validatePresence({
        presence: true,
        description: intl.t("validations.file-uploaded-journal-event.title")
      }),
      fileSubType: validatePresence({
        presence: true,
        description: intl.t(
          "validations.file-uploaded-journal-event.file-sub-type"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.file-uploaded-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "fileUploadedJournalEvents"
  })
  declare patient: Patient;

  override get summary() {
    return Object.assign({}, super.summary, {
      forcIdentifier: {
        feature: "file-uploaded",
        component: "edition-form"
      }
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "file-uploaded-journal-event": FileUploadedJournalEvent;
  }
}
